<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row v-if="listLoad">
        <v-col
          cols="12"
          md="6"
        >
          <v-skeleton-loader type="heading"  class="d-block mr-4 mb-3"></v-skeleton-loader>
        </v-col>
        <v-col         class="text-right"
          cols="12"
          md="4"
        >
          <v-skeleton-loader type="button"  class="d-block mr-4 mb-3"></v-skeleton-loader>
        </v-col>
    </v-row>
    <v-row v-if="listLoad">
      <v-col
        cols="12"
        md="3"
      >
        <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>
      
      <v-col
        cols="12"
        md="3"
      >
          <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
          <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-if="!listLoad">
      <v-col
        cols="12"
        md="6"
      >
        <span
          class="font-weight-medium ml-5 mr-5"
          style="font-size: 20px"
        >
          {{ portfolio.mnemonic }} - {{ portfolio.name }} 
        </span>
        <div>
          <v-btn
            color="primary"
            :to="'/portfolio/modify/'+$route.params.id"
            text
          >
            Edit Portfolio
          </v-btn>
        </div>
        <div class="font-weight-light caption  ml-5 mr-5">  
          Last Update: {{ formatDate(portfolio.modifiedOn) }}
        </div>
        
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        md="3"
      >
        <v-card
          color="lighten-1"
          class="mr-3"
          style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
          height='100%'
        >
          <v-card-title class="d-block text-center" style="color: #13305c; font-size: 18px; font-weight: bold;">
            Classification
          </v-card-title>
          <v-card-text class="text-center" style="font-size: 15px; color: white; font-weight: bold;">
            {{ portfolio.classification }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-card
          color="lighten-1"
          class="mr-3"
          style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
          height='100%'
          id="daysToTrade"
        >
          <v-card-title class="d-block text-center" style="color: #13305c; font-size: 18px; font-weight: bold;">
            Days to Trade
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon dense small style="color: #13305c; " v-on="on">mdi-alert-circle-outline </v-icon>
              </template>
              <span >{{ portfolio.pressure.info }}</span>
            </v-tooltip>                 
          </v-card-title>
          <v-card-text class="text-center" style="font-size: 15px; color: white; font-weight: bold;">
            {{ portfolio.pressure.daysToTrade }} days<br>
            <small>decile {{ portfolio.pressure.decile }}</small>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <v-card height='100%' v-if="insightsLoad">
          <v-skeleton-loader type="card" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>          
        </v-card>
        <v-card v-if="!insightsLoad">
          <v-card-title>
            <v-icon left large style="color:#f732df;">mdi-chart-timeline-variant</v-icon>
            <span id="insights">Insights</span>
          </v-card-title>
          <v-card-text v-if="!portfolio.constituents">
            This portfolio has no constituents. No analytics can be displayed.<br> 
            <v-btn text small  :to="'/portfolio/modify/' + id" color="primary">
                ADD CONSTITUENTS<v-icon v-text="'mdi-pencil'" ></v-icon>
            </v-btn>
          </v-card-text>
          <v-card-text v-if="portfolio.constituents">
              <v-expansion-panels accordion multiple hover>
                <v-expansion-panel v-if="portfolioInsights.performance.insights">
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Classification and Performance</v-col>
                      <v-col
                        cols="8"
                        class="text--secondary"
                      >
                      <v-fade-transition leave-absolute> 
                        <span
                          v-if="open"
                          key="0"
                        >
                        </span>
                        <span
                          v-else
                          key="1"
                        >
                        {{portfolioInsights.performance.insights.perf_short}}
                        </span>
                      </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters v-if="portfolioInsights">
                      <v-col cols="12" md="12" v-if="portfolioInsights.performance.insights.style">
                        {{portfolioInsights.performance.insights.style}} <v-btn text small  @click="$vuetify.goTo('#style')" color="primary">+</v-btn> <br>
                      </v-col>
                      <v-col cols="12" md="12" v-if="portfolioInsights.performance.insights.perf">
                        {{portfolioInsights.performance.insights.perf}}<v-btn text small  @click="$vuetify.goTo('#performance')" color="primary">+</v-btn><br>
                      </v-col>
                      <v-col cols="12" md="12" v-if="portfolioInsights.performance.insights.stocks">
                        {{portfolioInsights.performance.insights.stocks.text}}
                        <span v-for="(item, index) in portfolioInsights.performance.insights.stocks.stocks" :key="item.id">
                          <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :color="getColorBasedOnPerf(item.contrib)"
                                text
                                small 
                                v-bind="attrs"
                                v-on="on"                                
                              >
                                {{item.name}} {{item.text}}
                              </v-btn>
                            </template>
                            <v-list>
                              <v-subheader>{{item.name}}</v-subheader>
                              <v-list-item :to="'/stocks/analyze/' + item.id">
                                <v-list-item-title>    
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon color="primary" v-on="on" :to="'/stocks/analyze/' + item.id"  >
                                        <v-icon >mdi-magnify-plus-outline</v-icon>
                                      </v-btn>     
                                      Analyze stock
                                    </template>                      
                                    <span>Analyze</span>
                                  </v-tooltip>                                   
                                  </v-list-item-title>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-title><stock-set-preference :stock="item.id" :rating="item.preference"></stock-set-preference>Rate the stock</v-list-item-title>                      
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-title><stock-potential-replacement :stock="item.id" :title="item.name"></stock-potential-replacement>Check similar stocks</v-list-item-title>
                              </v-list-item>                              
                            </v-list>
                          </v-menu>  

                          <span v-if="index < portfolioInsights.performance.insights.stocks.stocks.length - 2">,</span>
                          <span v-if="index === portfolioInsights.performance.insights.stocks.stocks.length -2">and</span>

                        </span>.
   
                      </v-col>                       
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>             
                <v-expansion-panel v-if="portfolioInsights.performance.insights">
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Volume</v-col>
                    <v-col
                      cols="8"
                      class="text--secondary"
                    >
                    <v-fade-transition leave-absolute> 
                      <span
                        v-if="open"
                        key="0"
                      >
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                      {{portfolioInsights.performance.insights.volume_short}}
                      </span>
                    </v-fade-transition>
                    </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters v-if="portfolioInsights">
                      <v-col cols="12" md="12" v-if="portfolioInsights.performance.insights.volume">
                        {{portfolioInsights.performance.insights.volume}} <v-btn text small  @click="$vuetify.goTo('#style')" color="primary">+</v-btn> <br>
                      </v-col>                    
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="portfolioInsightsSummary">
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Portfolio Exposure</v-col>
                    <v-col
                      cols="8"
                      class="text--secondary"
                    >
                    <v-fade-transition leave-absolute> 
                      <span
                        v-if="open"
                        key="0"
                      >
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                      {{portfolioInsightsSummary}}
                      </span>
                    </v-fade-transition>
                    </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters v-if="portfolioInsights.expo">
                      <v-col cols="12" md="12" v-if="portfolioInsights.expo.insights">
                        <ul v-for="item in portfolioInsights.expo.insights" :key="item.name">
                          <li>{{item.name}} : {{item.general}} {{item.portfolio}}
                            <expo-distribution :title="item.name + ' Distribution'" :expo="item.id" :type="item.type" :ptf="id"></expo-distribution> <v-btn text small  @click="$vuetify.goTo('#expo')" color="primary">+</v-btn>
                          </li>
                        </ul>
                      </v-col>                    
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>    
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    

    <portfolio-analyze-component-chart-performance :ptf="id" v-if="portfolio.constituents"/>

    <portfolio-analyze-component-styles id="style" :ptf="id" v-if="portfolio.constituents"/>

    <portfolio-analyze-component-chart-volume :ptf="id" v-if="portfolio.constituents"/>

    <portfolio-analyze-component-highest-pressure :ptf="id" v-if="portfolio.constituents"/>

    <portfolio-analyze-component-lowest-pressure :ptf="id" v-if="portfolio.constituents"/>

    <!-- <portfolio-analyze-component-potential-buys :ptf="id"/> -->

    <portfolio-analyze-component-might-like :ptf="id" v-if="portfolio.constituents"/>

    <portfolio-analyze-component-might-avoid :ptf="id" v-if="portfolio.constituents"/>

    <portfolio-analyze-component-similar-investors :ptf="id" v-if="portfolio.constituents"/>

    <v-row class="my-2" v-if="portfolio.constituents">
      <v-col cols="12" md="6">
        <portfolio-analyze-component-sector-expo id="expo" :ptf="id"/>
      </v-col>
      <v-col cols="12" md="6">
        <portfolio-analyze-component-country-expo :ptf="id"/>
      </v-col>
    </v-row>

    <portfolio-analyze-component-portfolio :ptf="id" v-if="portfolio.constituents"/>

    <v-snackbar
      v-model="errorbar"
    >
      An error has occurred/No data found
      <v-btn
        color="pink"
        text
        @click="errorbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>    

  </v-container>
</template>

<script>
  import moment from 'moment'
  import { mapMutations } from 'vuex'
  import { algoReadyTourSteps } from '@/utils/constants'

  export default {
    name: 'portfolioAnalyze',
    props:['id'],    
    components: {
      //PortfolioAnalyzeComponentInsights: () => import('../components/portfolio/analyze/Insights'),
      PortfolioAnalyzeComponentChartPerformance: () => import('../components/portfolio/analyze/ChartPerformance'),
      PortfolioAnalyzeComponentStyles: () => import('../components/portfolio/analyze/Styles'),
      PortfolioAnalyzeComponentChartVolume: () => import('../components/portfolio/analyze/ChartVolume'),
      PortfolioAnalyzeComponentHighestPressure: () => import('../components/portfolio/analyze/HighestPressure'),
      PortfolioAnalyzeComponentLowestPressure: () => import('../components/portfolio/analyze/LowestPressure'),
      //PortfolioAnalyzeComponentPotentialBuys: () => import('../components/portfolio/analyze/PotentialBuys'),
      PortfolioAnalyzeComponentMightLike: () => import('../components/portfolio/analyze/MightLike'),
      PortfolioAnalyzeComponentMightAvoid: () => import('../components/portfolio/analyze/MightAvoid'),

      PortfolioAnalyzeComponentSectorExpo: () => import('../components/portfolio/analyze/SectorExpo'),
      PortfolioAnalyzeComponentCountryExpo: () => import('../components/portfolio/analyze/CountryExpo'),
      PortfolioAnalyzeComponentPortfolio: () => import('../components/portfolio/analyze/Portfolio'),
      PortfolioAnalyzeComponentSimilarInvestors: () => import('../components/portfolio/analyze/SimilarInvestors'),  
      ExpoDistribution: () => import('@/views/dashboard/components/portfolio/analyze/ExpoDistribution'),    

      StockPotentialReplacement: () => import('@/components/StockPotentialReplacement'),
      StockSetPreference: () => import('@/components/SetPreferences'),            
    },
    data() {
      return {
        listLoad: true,
        insightsLoad: true,
        errorbar: false,           
        portfolio: {},
        analyzeInfos: {
          totalMarketValue: 'Add to API',
          totalPotentialPressure: 'Add to API',
          daysToTrade: 'Add to API',
          potentialMarketImpact: 'Add to API',
        },
        portfolioInsights:null,
        portfolioInsightsSummary:null
      }
    },
    mounted () {
      this.getDataFromApi();
      this.getInsightsFromApi();
      this.activateTour(algoReadyTourSteps.portfolioAnalyze)
    },
    destroyed () {
      this.deactivateTour()
    },
    methods: {
      ...mapMutations({
        activateTour: 'ACTIVATE_ALGO_READY_TOUR',
        deactivateTour: 'DEACTIVATE_ALGO_READY_TOUR',
      }),
      getColorBasedOnPerf(contrib) {
        if (contrib>0) {
          return "primary"
        } else {
          return "#e9507f"
        }
      }, 
      formatDate(value) {
        return moment(String(value)).format("YYYY-MM-DD h:mm:ss")
      },
      goToPortfolio(id) {
        this.$router.push({ name: 'PortfolioAnalyze', params: { id: id } });
      },      
      async getDataFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-user-ptf-insights/' + self.id,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.portfolio = response.data
          self.listLoad = false
        }).catch(function () {
          self.listLoad = false
          self.errorbar = true
        })
      }, 
      async getInsightsFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-portfolio-insights-text/' + self.id,{},{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.portfolioInsights = response.data
          self.portfolioInsightsSummary = response.data.expo.summary
          self.insightsLoad = false
        }).catch(function () {
          self.insightsLoad = false
          //self.errorbar = true
        })
      },   
    },
  }
</script>


